<template>
    <v-card flat width="600px">
        <v-card-title class="pa-3 headline">Update Widget</v-card-title>
        <v-row class="pa-3 ma-0">

         
            <v-col cols="3" class="pa-1" justify="center" align="center">
                <v-card >
                    <v-img :src='(this.files.length) ? this.files[0].thumb : ""' contain style="height:100px;width:100%"></v-img>
                </v-card>
            </v-col>
            <v-col cols="8" class="pa-1" >
                <v-card
                    class="upload"
                    color="transparent"
                    min-height="200px"
                    flat
                >
                    <v-simple-table v-if="this.files.length">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">File Name</th>
                                    <th class="text-left"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(file,index) in files" :key="file.id">
                                    <td>{{ file.name }}</td>
                                    <td>
                                        <v-btn class="icon-btn" color="red" icon @click="files.splice(index,1)">
                                            <v-icon>mdi-file-remove</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    
                    <v-container 
                        class="fill-height pa-4"
                        fluid
                    > 
                        <v-row justify="center" align="center">
                            <v-btn width="220px">
                                <label for="file" class="btn btn-lg btn-primary" style="">
                                    Drop or Select Files
                                </label>
                            </v-btn>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
            <v-col cols="12">
                 <v-text-field label="Disply units" v-model="unitInput" hide-details="">
                </v-text-field>
            </v-col>
            <file-upload
                :multiple="true"
                :drop="true"
                :drop-directory="true"
                :maximum="1"
                accept="image/*"
                @input-filter="inputFilter"
                v-model="files"
                ref="upload"
                :headers="GetAuthHeaderObj()"
            ></file-upload>

            
        </v-row>

        <v-row justify="center" class="pa-0 ma-0 pt-4 pb-4">
            <v-btn
                v-if="!this.updatingWidget"
                style="width:100px"
                @click="Cancel()"
            >
                Cancel
            </v-btn>
            <v-col cols="1"></v-col>
            <v-btn
                style="width:150px"
                color="primary"
                @click="UpdateThumbnail()"
            >
                <v-icon 
                    v-if="this.updatingWidget" 
                    size="28" 
                    color="white" dark
                >
                    mdi-loading mdi-spin
                </v-icon>
                <span v-else>Confirm</span>
            </v-btn>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import FileUpload from 'vue-upload-component'

export default {
    name: "AttributeWidgetTemplate",
    components: {
        FileUpload
    },
    props: {
        //Widget model to use for update
        widget: {
            default : null,
            type : Object
        }
    },
    computed:{
        ...mapState("assetxpstate", [
            "section"
        ])
    },
    data: () => ({
        updatingWidget: false,
        files: [],
        file : {},
        unitInput : ""
    }),
    methods:{
         ...mapGetters("authentication", [
            "CanUserEditAssets",
            "GetAuthHeaderObj"
        ]),
        ...mapActions("assetxpstate", [
            "GetSectionAttributes",
            "UpdateWidget"
        ]),

        async UpdateThumbnail () {
            this.updatingWidget = true; 

            let formData = new window.FormData();
            formData.set('sectionId', this.section.id);
            formData.set('widgetId', this.widget.id);

            if(this.widgetType != 3) {
                for (var i = 0; i < this.$refs.upload.files.length; i++) {
                    var file = this.$refs.upload.files[i];
                    let value

                    for (let key in file.data) {
                    value = file.data[key]
                    if (value && typeof value === 'object' && typeof value.toString !== 'function') {
                        if (value instanceof File) {
                        formData.append(key, value, value.name)
                        } else {
                        formData.append(key, JSON.stringify(value))
                        }
                    } else if (value !== null && value !== undefined) {
                        formData.append(key, value)
                    }
                    }

                    formData.append(this.name, file.file, file.file.filename || file.name)
                }
            }

            formData.append("units",this.unitInput);

            this.UpdateWidget(formData).then((response) =>{
                this.updatingWidget = false;
                this.file = null;
                this.files = [];
                this.$emit('widgetUpdated', response.data);
            });
        },
        Cancel() {
            this.$emit('hideUpdateDialog');
        },
        inputFilter(newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Before adding a file
                // Filter system files or hide files
                if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                    return prevent()
                }

                // Filter php html js file
                if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                    return prevent()
                }
            }

            if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }

                // Thumbnails
                newFile.thumb = ''
                
                if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
                    newFile.thumb = newFile.blob
                }
            }
        }
    },
    watch: {
        widget : {
            immediate : true,
            handler(newVal)
            {

                if(newVal.units != null)
                {
                    this.unitInput = newVal.units;
                }else
                {
                    this.unitInput = "";
                }
                    
            }
        }
    }
}
</script> 

<style scoped> 
.v-btn {
    width: 30px;
    height: 30px;
    margin: 0px;
    padding: 0px;
}
.cardContent {
    margin: 0px; 
    padding: 5px;
}
</style>